import React from 'react';
import { LIVE_STATUS } from '../../../../common/constants';
import LiveUsersIcon from '../../../LiveUsersIcon';
import { getLiveBadgeText } from '../videoModules/live/liveVideoLabels';

function LiveIndicators({
  viewerCount = 0,
  uiLabels = {},
  showUserCount = false,
  state = 'live', // 'live', 'paused'
  onSeekToLive
}) {
  const badgeText = getLiveBadgeText(LIVE_STATUS.LIVE, uiLabels);

  const handleBadgeClick = () => {
    if (onSeekToLive && state === 'paused') {
      onSeekToLive();
    }
  };

  return (
    <div className="live-indicators">
      {showUserCount && (
        <div className="live-viewers">
          <LiveUsersIcon />
          <span>{viewerCount?.toLocaleString()}</span>
        </div>
      )}
      {badgeText && (
        <div
          className={`live-badge ${state} ${
            state === 'paused' ? 'clickable' : ''
          }`}
          onClick={handleBadgeClick}
        >
          <span>{badgeText}</span>
        </div>
      )}
    </div>
  );
}

export default LiveIndicators;
